<template>
    <v-container fluid>
      <ExportarIBMaker v-if="$store.state.emp.cod_empresa == 469"/>
      <ExportarJadip v-if="$store.state.emp.cod_empresa == 493"/>
      <ExporErret v-if="$store.state.emp.cod_empresa == 480"/>

    </v-container>
  </template>
  
  <script>

  import ExportarIBMaker from './IBM/ExporIBM.vue';
  import ExportarJadip from './Jadip/ExporJadip.vue';
  import ExporErret from './Erret/ExporErret.vue';
  
  export default {
    data: () => ({
      //
    }),
    components: {
        ExportarIBMaker,
        ExportarJadip,
        ExporErret
    },
  };
  </script>